import { Injectable } from "@angular/core";
import { SettingsService } from "../../shared/services/settings.service";

@Injectable({ providedIn: "root" })
export class NewAnkaadiaAnnouncementService {
  constructor(private readonly settings: SettingsService) {}

  shouldShowAnnouncement(): boolean {
    const { isCandidate, isNewUiEnabled, userHasSeenNewAnkaadiaAnnouncement } = this.settings;
    return isNewUiEnabled && !isCandidate && !userHasSeenNewAnkaadiaAnnouncement;
  }
}
